export default {
  root: {
    backgroundColor: '#CACACA',
  },
};
